var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPencilEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4 15C4 9.81455 4 7.22183 5.61091 5.61091C7.22183 4 9.81455 4 15 4C20.1854 4 22.7782 4 24.3891 5.61091C26 7.22183 26 9.81455 26 15C26 20.1854 26 22.7782 24.3891 24.3891C22.7782 26 20.1854 26 15 26C9.81455 26 7.22183 26 5.61091 24.3891C4 22.7782 4 20.1854 4 15Z",
    fill: "#11B9B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.928 17.3018C17.173 17.1107 17.3952 16.8885 17.8396 16.4441L23.38 10.9037C23.5139 10.7698 23.4526 10.5391 23.2737 10.477C22.6197 10.2501 21.769 9.82414 20.9732 9.02835C20.1774 8.23257 19.7514 7.38186 19.5246 6.72788C19.4625 6.54892 19.2318 6.48761 19.0978 6.62156L13.5575 12.1619C13.113 12.6063 12.8908 12.8285 12.6997 13.0736C12.4743 13.3626 12.281 13.6753 12.1233 14.0062C11.9897 14.2867 11.8903 14.5848 11.6915 15.181L11.4347 15.9515L11.0264 17.1765L10.6435 18.3252C10.5457 18.6186 10.622 18.9421 10.8407 19.1608C11.0594 19.3795 11.3829 19.4559 11.6764 19.3581L12.825 18.9752L14.0501 18.5668L14.8205 18.31L14.8205 18.31C15.4168 18.1113 15.7149 18.0119 15.9954 17.8782C16.3263 17.7205 16.639 17.5273 16.928 17.3018Z",
    fill: "#11B9B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1147 9.16905C26.2972 7.98656 26.2972 6.06936 25.1147 4.88687C23.9322 3.70438 22.015 3.70438 20.8325 4.88687L20.6544 5.06499C20.4825 5.23687 20.4046 5.47695 20.4476 5.7162C20.4746 5.8667 20.5247 6.08674 20.6158 6.3493C20.7979 6.87439 21.142 7.56368 21.7899 8.21165C22.4379 8.85961 23.1272 9.20364 23.6523 9.38581C23.9148 9.4769 24.1349 9.52697 24.2854 9.55399C24.5246 9.59693 24.7647 9.51905 24.9366 9.34717L25.1147 9.16905Z",
    fill: "#11B9B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencilEdit);
export default __webpack_public_path__ + "static/media/icon_pencil_edit.a0a3536d937536ae908d315fbf391836.svg";
export { ForwardRef as ReactComponent };